<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.pa-4
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center Mark as no-show
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-close
      v-divider
      v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-8'")
        div.d-flex.justify-center.mt-16(v-if="isFetching")
          v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

        template(v-else-if="appointment")
          div.text-md.font-semibold.neutral700--text Are you sure you want to mark this patient as no-show?

          v-card.mt-4.pa-4.round-lg(outlined)
            v-row(dense)
              v-col(cols="6")
                div.text-xs.neutral500--text {{ $t('name') }}
                div.text-sm.neutral700--text.mt-1 {{ appointment.lead.name || '-' }}
              v-col(cols="6")
                div.text-xs.neutral500--text {{ $t('nric_passport') }}
                div.text-sm.neutral700--text.mt-1 {{ appointment.lead.ic || '-' }}
              v-col.pt-3(cols="6")
                div.text-xs.neutral500--text {{ $t('service') }}
                div.text-sm.neutral700--text.mt-1 {{ appointment.service.name || '-' }}
              v-col.pt-3(cols="6")
                div.text-xs.neutral500--text {{ $t('doctor') }}
                div.text-sm.neutral700--text.mt-1 {{ appointment.provider.name || '-' }}
              v-col.pt-3(cols="6")
                div.text-xs.neutral500--text {{ $t('date') }}
                div.text-sm.neutral700--text.mt-1 {{ $options.filters.humanizeDate(appointment.date) || '-' }}
              v-col.pt-3(cols="6")
                div.text-xs.neutral500--text {{ $t('time') }}
                div.text-sm.neutral700--text.mt-1 {{ $options.filters.displayTime2(appointment.time) || '-' }}

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-btn.button-md.neutral700--text.px-0(@click="closeDialog" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md(:loading="isLoading" color="danger500" depressed dark @click="confirmAction") Mark as no show

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CancelAppointment',
  components: {},
  props: ['open', 'selectedAppointment'],
  data () {
    return {
      isFetching: false,
      isLoading: false,
      appointment: null,
      remarks: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  mounted () {
    this.fetchAppointment()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchAppointment () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/appointments/${this.selectedAppointment.id}`)
        .then(resp => {
          this.appointment = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    confirmAction () {
      this.isLoading = true
      let data = {
        status: 'absent'
      }
      const endpoint = `/clinics/${this.company.slug}/appointments/${this.selectedAppointment.id}`
      this.$axios.patch(endpoint, data)
        .then(resp => {
          this.updateActivityLog(endpoint, data, resp, 'PATCH', this.selectedAppointment.id)
          this.closeResetDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeResetDialog () {
      this.showDialog = false
      this.$emit('reset')
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'appointment',
        activity: 'Update appointment as no-show',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>